import gsap from 'gsap';

const SCALE = window.devicePixelRatio || 1;
const FRAMES = 100;
const RADIUS = 39;
const SIZE = 132;

class PlayBackCircle {
  constructor(loopDuration) {
    this.loopDuration = loopDuration;
    this.progress = 0;
    this.center = { x: 0, y: 0 };
    this.container = document.getElementById('play-container');
    this.strokesCanvas = document.getElementById('player-strokes-canvas');
    this.strokesCanvasContext = this.strokesCanvas.getContext('2d');
    this.bgElement = document.getElementById('player-bg');
    this.cursor = document.getElementById('player-cursor');
    this.iconPaths = this.container.querySelectorAll('path');

    this.color = null;
    this.complementaryColor = null;

    this.shapes = null;
  }

  shapesChanged(shapes) {
    this.shapes = shapes;
    this.drawStrokes();
  }

  resize() {
    this.center.x = SIZE / 2 * SCALE;
    this.center.y = (SIZE - 29 - RADIUS) * SCALE;
    this.strokesCanvas.width = SIZE * SCALE;
    this.strokesCanvas.height = SIZE * SCALE;
    this.strokesCanvas.style.width = `${SIZE}px`;
    this.strokesCanvas.style.height = `${SIZE}px`;

    this.drawBackground();
    this.drawStrokes();
    this.drawProgress();
  }

  changeColor(color, complementaryColor) {
    this.color = color.toLowerCase();
    this.complementaryColor = complementaryColor;
    for (const path of this.iconPaths) {
      path.style.fill = this.complementaryColor;
    }
    this.drawBackground();
    this.drawStrokes();
    this.drawProgress();
  }

  setProgress(progress) {
    this.progress = progress;
    this.drawProgress();
  }

  drawStrokes() {
    if (!this.shapes || !this.complementaryColor) {
      return;
    }
    const layerFrames = [];
    const strokeTimings = [];
    const oneFrameTiming = 1 / FRAMES;
    for (const shape of this.shapes.history) {
      const start = !shape.isStroke ? shape.loopTime / this.loopDuration : shape.startLoopTime / this.loopDuration;
      let end = !shape.isStroke ? start + oneFrameTiming : shape.points[shape.points.length - 1].loopTime / this.loopDuration;
      if (end > 1) {
        end = 0;
      }
      const color = shape.hexColor;
      if (end < start) {
        strokeTimings.push({
          start: start,
          end: 1,
          color: color
        });
        strokeTimings.push({
          start: 0,
          end: end,
          color: color
        })
      } else {
        strokeTimings.push({
          start: start,
          end: end,
          color: color
        })
      }
    }
    for (let index = 0; index < FRAMES; index++) {
      const progress = index / FRAMES;
      const colors = [];
      for (const stroke of strokeTimings) {
        if (progress >= stroke.start && (progress <= stroke.end)) {
          colors.push(stroke.color);
        }
      }
      layerFrames.push(colors);
    }

    // draw
    this.strokesCanvasContext.clearRect(0, 0, this.strokesCanvas.width, this.strokesCanvas.height);
    this.strokesCanvasContext.lineWidth = Math.max(1, 2 * Math.PI * RADIUS / FRAMES * SCALE);

    let i = 0;
    const innerRadius = RADIUS * SCALE;
    const h = 3 * SCALE;
    const maxIterations = this.borderSize / h;

    for (const frame of layerFrames) {
      const colorCount = frame.length;
      if (colorCount) {
        let j = 0;
        const angle = (i / FRAMES * 360 - 90) * Math.PI / 180;
        const cosAngle = Math.cos(angle);
        const sinAngle = Math.sin(angle);
        for (const color of frame) {
          this.strokesCanvasContext.strokeStyle = color;
          const layerSpace = j * h;
          const outerRadius = innerRadius + h + layerSpace;
          this.strokesCanvasContext.beginPath();
          this.strokesCanvasContext.moveTo(this.center.x + cosAngle * (innerRadius + layerSpace), this.center.y + sinAngle * (innerRadius + layerSpace));
          this.strokesCanvasContext.lineTo(this.center.x + cosAngle * outerRadius, this.center.y + sinAngle * outerRadius);
          this.strokesCanvasContext.stroke();
          this.strokesCanvasContext.closePath();
          j++;
          if (j > maxIterations) {
            break;
          }
        }
      }
      i++;
    }

  }

  drawBackground() {
    this.bgElement.style.borderColor = this.complementaryColor;
    this.bgElement.style.backgroundColor = this.color;
    this.cursor.style.borderColor = this.complementaryColor;
  }

  drawProgress() {
    gsap.set(this.cursor, { rotation: this.progress * 360 })
  }

  reset() {
    this.setProgress(0);
  }
}

export { PlayBackCircle };